import { Injectable } from '@angular/core';
import { TypeCPVClass } from '../../models/TypeCPVClass';
import { TypeDescMarche } from '../../models/TypeDescMarche';
import { TypeFournitures } from '../../models/TypeFournitures';
import { TypeLieu } from '../../models/TypeLieu';
import { TypeObjCPV } from '../../models/TypeObjCPV';
import { TypeTravaux } from '../../models/TypeTravaux';
import { TypeVoie } from '../../models/TypeVoie';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root'
})
export class DescriptionService {

  constructor(private avisDataTransferService: AvisDataTransferService) { }

  getDescription(controls, formExtractorService): TypeDescMarche {
     const objetComplClassSupplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['TypeDescMarche', 'TypeObjCPV', 'TypeCPVClass', 'classSupplementaire'], '_SepSep_TypeCPVClass_index_');
     const objetComplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['TypeDescMarche', 'TypeObjCPV'], '_SepSep_TypeObjCPV_index_');

     let objetComplementaire_iter = 0;
     let objetComplClassSupplementaire_iter = 0;

     const description = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.rectificatifFromMAPA.description;

     description.marcheServices = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_marcheServices');
     description.objet = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_objet');

     description.cpv = new TypeObjCPV();

     objetComplementaire_iters.forEach(() => {
      description.cpv.objetComplementaire[objetComplementaire_iter] = new TypeCPVClass();
      description.cpv.objetComplementaire[objetComplementaire_iter].classSupplementaire = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_SepAtt_classSupplementaire');
      description.cpv.objetComplementaire[objetComplementaire_iter].classPrincipale = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_SepAtt_classPrincipale');

      objetComplementaire_iter++;
    });

     description.marcheTravaux = new TypeTravaux();
     description.marcheTravaux.execution = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeTravaux_SepAtt_execution');
     description.marcheTravaux.conceptionRealisation = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeTravaux_SepAtt_conceptionRealisation');

     const lieuExecutionLivraison = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_lieuExecutionCB');
     if(lieuExecutionLivraison) {
      description.lieuLivraison = null;
      description.lieuExecution = null;
      description.lieuExecutionLivraison = new TypeLieu();
      description.lieuExecutionLivraison.ville = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_ville');
      description.lieuExecutionLivraison.cp = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp');

      description.lieuExecutionLivraison.voie = new TypeVoie();
      description.lieuExecutionLivraison.voie.num = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num');
      description.lieuExecutionLivraison.voie.nomvoie = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie');
      description.lieuExecutionLivraison.voie.typevoie = controls.get('lieuExecutionLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie');
     } else {
      description.lieuExecutionLivraison = null;
      description.lieuLivraison = new TypeLieu();
      description.lieuLivraison.cp = controls.get('lieuLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp');
      description.lieuLivraison.ville = controls.get('lieuLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_ville');
 
      description.lieuLivraison.voie = new TypeVoie();
      description.lieuLivraison.voie.nomvoie = controls.get('lieuLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie');
      description.lieuLivraison.voie.num = controls.get('lieuLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num');
      description.lieuLivraison.voie.typevoie = controls.get('lieuLivraison_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie');
      description.lieuExecution = new TypeLieu();
      description.lieuExecution.cp = controls.get('lieuExecution_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp');
      description.lieuExecution.ville = controls.get('lieuExecution_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_ville');
     
      description.lieuExecution.voie = new TypeVoie();
      description.lieuExecution.voie.num = controls.get('lieuExecution_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num');
      description.lieuExecution.voie.nomvoie = controls.get('lieuExecution_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie');
      description.lieuExecution.voie.typevoie = controls.get('lieuExecution_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie');
     }
     description.isLieuExecutionLivraison = lieuExecutionLivraison;
     description.marcheFournitures = new TypeFournitures();
     description.marcheFournitures.locationVente = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_locationVente');
     description.marcheFournitures.location = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_location');
     description.marcheFournitures.achat = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_achat');
     description.marcheFournitures.creditBail = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeFournitures_SepAtt_creditBail');

     description.cpv.objetPrincipal = new TypeCPVClass();
     description.cpv.objetPrincipal.classSupplementaire = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classSupplementaire');
     description.cpv.objetPrincipal.classPrincipale = controls.get('_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale');


     return description;
  }
}
